import React, { Component } from 'react';
import { connect } from 'react-redux';

import { logoutUser } from '../../actions';

class Profile extends Component{

    componentDidMount() {
        window.$('[data-toggle="tooltip"]').tooltip();
      }
      
      componentDidUpdate() {
        window.$('[data-toggle="tooltip"]').tooltip();
      }
    
   
    
    render(){
        let {name,pic} = this.props;
        return(
            <div className='row profile-row'>
                <div className='profile'>
                <div className='profile-pic' 
                     ><img alt="Profile pic" src={pic}
                     data-toggle='tooltip' 
                     title={name}/></div>
                <div className='profile-name'><div onClick={()=>this.props.logoutUser()}>Sign Out</div></div>
                
                </div>
                

                
              
            </div>
        )
    }
}

// function mapStateToProps(state){
//     console.log(state);
// }

export default connect(null,{logoutUser})(Profile);


// WEBPACK FOOTER //
// ./src/components/goals/Profile.jsx